<div>
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div>
    <ag-grid-angular
      style="width: 100%; height: 100%"
      class="ag-theme-alpine"
      rowSelection="multiple"
      rowHeight="48"
      rowMultiSelectWithClick="false"
      suppressRowClickSelection="true"
      suppressDragLeaveHidesColumns="true"
      suppressMenuHide="true"
      suppressContextMenu="true"
      enableCellTextSelection="true"
      [icons]="customIcons"
      [columnDefs]="columnDefs"
      [tooltipShowDelay]="500"
      [defaultColDef]="defaultColDef"
      [paginationPageSize]="paginationPageSize"
      [pagination]="true"
      [suppressPaginationPanel]="true"
      [suppressCellSelection]="true"
      [getMainMenuItems]="getMainMenuItems"
      [suppressScrollOnNewData]="true"
      [rowData]="rowData"
      [domLayout]="domLayout"
      (columnMoved)="onColumnMoved($event)"
      (columnResized)="onColumnResized($event)"
      (columnVisible)="onColumnVisible($event)"
      (sortChanged)="onSortChange()"
      (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>

  <div class="d-flex justify-content-between align-items-center my-15 has-pagination">
    <div class="pagination-left">
      <app-pagination
        *ngIf="totalRowsCount > paginationPageSize"
        [totalItems]="totalRowsCount"
        [(currentPage)]="currentPageNumber"
        (change)="onPageChange($event)"
        [pageSize]="paginationPageSize"></app-pagination>
    </div>

    <div class="d-flex align-items-center justify-content-end pagination-right">
      <span class="pagination-count"
        >Showing {{ totalRowsCount > paginationPageSize ? paginationPageSize : totalRowsCount }} of {{ totalRowsCount }} results</span
      >
      <ul *ngIf="sizes.length" class="pagination">
        <li *ngFor="let size of sizes" [ngClass]="{ active: size === paginationPageSize }">
          <a (click)="changeSize($event, size)">{{ size }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #taskSettingsModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Task settings</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body task-settings">
    <div [hidden]="!loading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <div class="d-flex modal-tabs-vertical">
      <ul class="nav flex-column">
        <div *ngFor="let section of taskSettingsDetails" (click)="scrollTo(section.id)">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === section.id }">
            <span class="nav-text"> {{ section.title }}</span>
          </a>
        </div>
      </ul>

      <div class="tab-content section-parent" id="parentDiv" scrollSpy [spiedTags]="['DIV']" (sectionChange)="onSectionChange($event)">
        <div *ngFor="let section of taskSettingsDetails" [id]="section.id" class="section-child">
          <ul class="modal-tab-list modal-tab-table-list">
            <li class="title">{{ section.title }}</li>
            <li *ngFor="let details of section.data">
              <span class="left-col">{{ details[0] }}</span>
              <span class="right-col" [innerHTML]="details[1]"></span>
            </li>
          </ul>
        </div>
        <!-- This below element is needed to have last section in focus when scrolling ... -->
        <div class="section-empty-child"></div>
      </div>
    </div>
  </div>

  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      <button class="btn btn-outline-primary" [disabled]="!taskSettingsDetails[0]" (click)="dialogRef.close(true)">View task in scheduler</button>
    </div>
  </div>
</ng-template>

<ng-template #commentModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Comment</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <textarea class="form-control comment" [formControl]="commentTextFormControl"></textarea>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between align-items-center">
      <button class="btn btn-outline-dark px-20" (click)="dialogRef.close(false)">Cancel</button>
      <button class="btn btn-primary px-20" (click)="onCommentSave()" [disabled]="loading">Save</button>
    </div>
  </div>
</ng-template>
